









































import 'vue-awesome/icons/times'
import 'vue-awesome/icons/regular/plus-square'
import 'vue-awesome/icons/regular/minus-square'

CategoriesGrouper = require('./categories_grouper.coffee')
LIMIT_NUMBER = 5

export default
  name: 'transactions_stats'
  components:
    balance:      require('components/inside/elements/balance.vue').default
    category_row: require('./category_row.vue').default
    treemap:      require('./categories_stats/treemap.vue').default
  props: ['transactions', 'from', 'months_count']
  data: ->
    LIMIT_NUMBER: LIMIT_NUMBER
    categories_limit: LIMIT_NUMBER
    mode: 'real'
    disabled:
      real: false
      plan: false
    opened_categories: {}
    all_opened: false
  computed:
    all_categories: ->
      incomes: CategoriesGrouper(@transactions, 'incomes', @$store, @mode)
      expenses: CategoriesGrouper(@transactions, 'expenses', @$store, @mode)
    limited_categories: ->
      incomes:  _.take(@all_categories.incomes.categories, @categories_limit)
      expenses: _.take(@all_categories.expenses.categories, @categories_limit)
    can_display_more: ->
      @all_categories.incomes.categories.length > @categories_limit || @all_categories.expenses.categories.length > @categories_limit
    can_toggle_subcategories: ->
      expenses_subs = _.compact(_.map(@limited_categories.expenses, 'subcategories')).length > 0
      incomes_subs  = _.compact(_.map(@limited_categories.incomes, 'subcategories')).length > 0
      expenses_subs || incomes_subs
  methods:
    is_opened: (category) ->
      @opened_categories[category.subtype_and_name] || false
    toggleSubcategories: (category, is_visible) ->
      return unless category.subcategories
      @opened_categories[category.subtype_and_name] = is_visible
      @opened_categories = _.clone @opened_categories
    openAll: ->
      for category in _.flatten(Object.values @limited_categories)
        @toggleSubcategories(category, true)
      @all_opened = true
    closeAll: ->
      for category in _.flatten(Object.values @limited_categories)
        @toggleSubcategories(category, false)
      @all_opened = false
